<div #dialogRoot cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title cdkDragHandle>{{ title }}<span style="color: orange;">{{disableAllNoneMsg}}</span></h2>
<div class="dialog-icon-row">
    <button mat-icon-button (click)="refresh()" [matTooltip]="refreshTooltip" *ngIf="showRefresh">
        <img src="assets/images/download_default.png"
            alt="Copy JSON"
            style="width: 24px; height: 20px;" />
    </button>
    <button mat-icon-button (click)="import()" matTooltip="Import">
        <mat-icon color="primary">file_upload</mat-icon>
    </button>
    <button mat-icon-button (click)="Export()" matTooltip="Export">
        <mat-icon color="primary">file_download</mat-icon>
    </button>
    <button mat-icon-button (click)="CopyJSON()" matTooltip="Copy JSON">
        <img src="assets/images/Copy JSON Button.png"
            alt="Copy JSON"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="CopyText()" matTooltip="Copy Text">
        <img src="assets/images/Copy Text Button.png"
            alt="Copy Text"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="PasteJSON()" matTooltip="Paste JSON">
        <img src="assets/images/Paste JSON Button.png"
            alt="Paste JSON Button"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button (click)="PasteText()" matTooltip="Paste Text">
        <img src="assets/images/Paste Text Button.png"
            alt="Paste Text"
            style="width: 24px; height: 24px;" />
    </button>
    <button mat-icon-button  class="red-icon-btn"(click)="DeleteAll()" matTooltip="Delete All">
        <mat-icon>delete_sweep</mat-icon>
    </button>
</div>

<mat-dialog-content>
     <div class="row-container" >
        <div style="visibility: hidden;">
            <!-- <mat-icon
                color="primary"
                matTooltip="Re-order"
                matTooltipPosition="above"
                #reorderTooltip="matTooltip"
                style="cursor: grab; font-size: 20px;line-height: 20px;margin-top: 9px;"
                cdkDrag
                cdkDragRootElement=".drag-component"
                cdkDragHandle
                >
                reorder
            </mat-icon>
         
            <span class="number-badge" style="margin-top: 17px;margin-left: -10px;">
                    &nbsp; 1 &nbsp;
                </span> -->
                 <mat-icon
                    color="primary"
                   color="primary"
                   matTooltip="Re-order"
                    matTooltipPosition="above"
                    #reorderTooltip="matTooltip"
                    style="cursor: grab; font-size: 20px;line-height: 20px;margin-top: 9px;"
                    cdkDrag
                    cdkDragRootElement=".drag-component"
                    cdkDragHandle
                  >
                    reorder
                </mat-icon>
                <!-- Number: positioned tightly to top-right corner -->
                <span class="number-badge" style="margin-top: 7px;margin-left: -10px;">
                    &nbsp;1&nbsp;&nbsp;
                </span>
        </div>
        <div [ngSwitch]="fieldType" class="field-container">
            <!-- edit -->
            <ng-container *ngSwitchCase="'edit'">
                <mat-form-field #textboxmatform style="width: 400px; height: auto;" appearance="outline" floatLabel="always">
                    <mat-label>{{label}}</mat-label>
                    <input #textbox  id="add-input" cdkFocusInitial style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.currentName" placeholder="{{placeholder}}" (keydown.enter)="validateSelection()">
                    <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                    <button matSuffix style="margin-left: 10px;margin-bottom: 2px;" title="Add" (click)="validateSelection()" mat-icon-button>
                        <mat-icon class="icon" color="primary">add_box</mat-icon>
                    </button>
                </mat-form-field>
            </ng-container>
            <!-- Dropdown -->
            <ng-container *ngSwitchCase="'dropdown'"  style=" padding: 0px !important;  ">
                <mat-form-field #textboxmatform  style="width: 400px; height: auto;" appearance="outline" floatLabel="always">
                    <mat-label>{{label}}</mat-label>
                    <mat-select [(ngModel)]="viewModel.currentName"  id="add-input" cdkFocusInitial style="margin-left: 5px;height: 20px;"  (keydown.enter)="validateSelection()" [disabled]="disableAllNone" (selectionChange)="onSelectDropDown($event)" >
                        <mat-option value="" disabled>Select Value</mat-option>
                        <mat-option *ngFor="let option of options" [value]="option" >
                            {{ option }}
                        </mat-option>
                    </mat-select>
                    <div matPrefix class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                    <button matSuffix style="margin-left: 10px;padding-bottom: 10px;" title="Add" (click)="validateSelection()" mat-icon-button>
                        <mat-icon class="icon" color="primary">add_box</mat-icon>
                    </button>
                </mat-form-field>
            </ng-container>
            <!-- autocomplete -->
            <ng-container *ngSwitchCase="'autocomplete'">
                <mat-form-field *ngSwitchCase="'autocomplete'" #textboxmatform  style="width: 400px; height: auto;" appearance="outline" floatLabel="always">
                    <mat-label>{{label}}</mat-label>
                    <input #textbox matInput  id="add-input" cdkFocusInitial style="margin-left: 5px;height: 20px;" [formControl]="myControl" [matAutocomplete]="auto" [(ngModel)]="viewModel.currentName" placeholder="{{placeholder}}" 
                        (keydown.enter)="validateSelection()">
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                    <div matPrefix 
                     class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                    <button matSuffix style="margin-left: 10px;margin-bottom: 2px;" title="Add" (click)="validateSelection()" mat-icon-button>
                        <mat-icon class="icon" color="primary" >add_box</mat-icon>
                    </button>
                </mat-form-field>
            </ng-container>
        </div>
    </div>
    <div class="dashed-line"></div>
    <div>
        <div cdkDropList [cdkDropListData]="viewModel.textItems" (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let item of viewModel.textItems;let i = index">
            <div class="row-container"  [attr.data-row-index]="i">
                <mat-icon
                    color="primary"
                    matTooltip="Re-order"
                    matTooltipPosition="above"
                    #reorderTooltip="matTooltip"
                    (mouseenter)="reorderTooltip.show()"
                    (mouseleave)="reorderTooltip.hide()"
                    style="cursor: grab; font-size: 20px;line-height: 20px;margin-top: 9px;"
                    cdkDrag
                    cdkDragRootElement=".drag-component"
                    cdkDragHandle
                >
                    reorder
                </mat-icon>
                <!-- Number: positioned tightly to top-right corner -->
                <span class="number-badge" style="margin-top: 7px;margin-left: -5px;">
                    &nbsp;{{ i + 1 }}&nbsp;
                </span>
                <div [ngSwitch]="fieldType" class="field-container" >
                    <!-- edit -->               
                    <ng-container *ngSwitchCase="'edit'">
                        <mat-form-field class="mat-form-field-no-padding" style="width: 400px; height: auto;" appearance="outline" floatLabel="auto">
                            <input style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.text" placeholder="{{placeholder}}" required>
                            <div matPrefix 
                             class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            <button matSuffix style="margin-left: 10px;padding-bottom: 10px;"  mat-icon-button>
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)">delete_forever</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>
                    <!-- Dropdown -->
                    <ng-container *ngSwitchCase="'dropdown'">
                        <mat-form-field style="width: 400px; height: auto;" appearance="outline" floatLabel="auto">
                            <mat-select [(ngModel)]="item.text" style="margin-left: 5px;height: 20px;"  (openedChange)="storePreviousValue(item.text)" (selectionChange)="onCheckDuplicate($event, item)" [disabled]="disableAllNone">
                                <mat-option *ngFor="let option of optionsDropdown" [value]="option">
                                {{ option }}
                                </mat-option>
                            </mat-select>
                            <div matPrefix class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            <button matSuffix style="margin-left: 10px;padding-bottom: 10px;" mat-icon-button>
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)">delete_forever</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>
                    <!-- autocomplete -->
                    <ng-container *ngSwitchCase="'autocomplete'">
                        <mat-form-field class="mat-form-field-no-padding" style="width: 400px; height: auto;" appearance="outline" floatLabel="auto">
                            <input matInput style="margin-left: 5px;height: 20px;margin-bottom: 2px;" [matAutocomplete]="auto" [(ngModel)]="item.text" placeholder="{{placeholder}}" required
                            (focus)="savePreviousValue(item.text)" (blur)="checkValue(item)" [disabled]="disableAllNone">
                            <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                    {{ option }}
                                </mat-option>
                            </mat-autocomplete>
                            <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                            <button matSuffix style="margin-left: 10px;margin-bottom: 2px;"  mat-icon-button     [attr.data-delete-btn]="i">
                                <mat-icon class="icon red-icon" (click)="deleteItem(item)">delete_forever</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>
                </div>
            </div>
            <div class="dashed-line" style=" margin-bottom: 10px;"></div>
        </ng-container>
        </div>
        <h3 style="color: #1ea9d3 !important; margin-top: 5px; font-size: 14px;">Preview</h3>

        <div style="white-space: normal; word-wrap: break-word;"><span 
               style="margin-left: 2px; margin-right: 2px;white-space: pre;font-size: 14px;"
                *ngFor="let containItem of viewModel.textItems"
                [style.color]="containItem.color.color">{{containItem.text}}</span></div>
    </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button (click)="save()"  class="save-btn" color="primary" mat-raised-button  >SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close >CANCEL</button>
</mat-dialog-actions>
</div>
<a #fakeclick></a> 